import { render, staticRenderFns } from "./SentimentCatIndia.vue?vue&type=template&id=24a55852&scoped=true"
import script from "./SentimentCatIndia.vue?vue&type=script&lang=js"
export * from "./SentimentCatIndia.vue?vue&type=script&lang=js"
import style0 from "./SentimentCatIndia.vue?vue&type=style&index=0&id=24a55852&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24a55852",
  null
  
)

export default component.exports